__turbopack_context__.v({
  "burger-icon": "burger-icon-component-module-scss-module__P62gsa__burger-icon",
  "burger-icon--active": "burger-icon-component-module-scss-module__P62gsa__burger-icon--active",
});
